import { CompanyData } from './tabs/CompanyData'
import { AddNewCompany } from './tabs/AddNewCompany'
import { AddRepresentanteLegal } from './tabs/AddRepresentanteLegal'
import { Plan } from './tabs/Plan'
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faX } from '@fortawesome/free-solid-svg-icons'
import { UserAuth } from '../../../../context/AuthContext'
import { useGlobalContext } from '../../../../context/GlobalState'
import { useSlide } from './tabs/useSlideHook'
import ContactSupport from './tabs/ContactSupport'
import PlanRestrictedButton from '../../../modules/ui/PlanRestrictedButton'
// import AddRepresentanteElectronic from './tabs/AddRepresentanteElectronic'
// import { Users } from './tabs/users/Users'
// import { Roles } from './tabs/roles/Roles'

/**
 * @typedef {Object} SettingsProps
 * @property {CallableFunction} onClose
 */

/**
 * A component that renders a Formik field with an error message.
 * @param {SettingsProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
export const Settings = ({ onClose }) => {
  const { slide, setSlide } = useSlide()
  const { logout } = UserAuth()
  const { currentBusiness } = useGlobalContext()
  const hasRepresentanteLegal = Boolean(currentBusiness?.rutRepresentante)

  const slides = [
    <CompanyData key={1} />,
    <AddNewCompany key={2} onClose={onClose} />,
    // <AddRepresentanteElectronic key={3} />,
    <AddRepresentanteLegal key={3} />, 
    <Plan key={4} />,
    <ContactSupport key={5}/>
  ]

  const HeaderTitle = () => (
    <header className='mb-4 sm:mb-8 flex items-center justify-between border-b-2 border-slate-300 py-2'>
      <h2 className='text-lg sm:text-xl font-sans font-bold'>Configuración</h2>
    </header>
  )

  const TabsList = () => (
    <ul className='flex flex-row sm:flex-col gap-3 sm:gap-4 w-full sm:w-52 overflow-x-auto sm:overflow-visible font-sans pb-2 sm:pb-0 sm:pr-2'>
      <li>
        <button
          className={slide === 0 ? 'font-bold whitespace-nowrap text-left' : 'whitespace-nowrap text-left'}
          type='button'
          onClick={() => setSlide(0)}
        >
          Datos de la empresa
        </button>
      </li>
       <li>
        <PlanRestrictedButton
          checkBusinessLimit
          message="Agregar más empresas"
          keepEnabled
          canAddAddon={true}
          onClick={() => setSlide(1)}
        >
          <button
            className={slide === 1 ? 'font-bold whitespace-nowrap text-left' : 'whitespace-nowrap text-left'}
            type='button'
          >
            Agregar empresa
          </button>
        </PlanRestrictedButton>
      </li>
      {/* <li>
        <button
          className={slide === 2 ? 'font-bold whitespace-nowrap text-left' : 'whitespace-nowrap text-left'}
          type='button'
          onClick={() => setSlide(2)}
        >
          Representante Electronico
        </button>
      </li> */}
      <li>
        <button
          className={slide === 2 ? 'font-bold whitespace-nowrap text-left' : 'whitespace-nowrap text-left'}
          type='button'
          onClick={() => setSlide(2)}
        >
          {hasRepresentanteLegal ? 'Actualizar representante legal' : 'Agregar representante legal'}
        </button>
      </li>
      {/* <li>
        <button
          className={slide === 3 ? 'font-bold' : ''}
          type='button'
          onClick={() => setSlide(3)}
        >
          Usuarios
        </button>
      </li> */}
      {/* <li>
        <button
          className={slide === 4 ? 'font-bold' : ''}
          type='button'
          onClick={() => setSlide(4)}
        >
          Roles
        </button>
      </li> */}
      {/* <li>
        <button
          className={slide === 3 ? 'font-bold' : ''}
          type='button'
          onClick={() => setSlide(3)}
        >
          Plan
        </button>
      </li> */}
      <li>
        <PlanRestrictedButton
          requiredSupport="email"
          message="Soporte por email"
          keepEnabled
          onClick={() => setSlide(4)}
        >
          <button
          className={slide === 4 ? 'font-bold whitespace-nowrap text-left' : 'whitespace-nowrap text-left'}
          type='button'
          >
            Soporte
          </button>
        </PlanRestrictedButton>
      </li>
      <li>
        <button onClick={logout} type='button' className='whitespace-nowrap text-left'>
          Cerrar sesión
        </button>
      </li>
    </ul>
  )

  const TabsContent = () => (
  <div className='relative bg-white rounded-2xl shadow-md flex flex-col flex-1 min-w-0 overflow-hidden'>
    <section
      style={{ scrollbarWidth: 'thin', scrollbarColor: '#c7c7c7 #f5f5f5' }}
      className='flex-1 overflow-y-auto p-3 sm:p-4' >
      {slides[slide]}
    </section>
  </div>
)


  return (
    <div className='text-base p-4 sm:p-8 pt-3'>
      <HeaderTitle />

      <section className='flex flex-col sm:flex-row gap-4 sm:gap-7'>
        <TabsList />

        <TabsContent />
      </section>
    </div>
  )
}
